<template>
  <div class="index-wrapper">
    <c-header></c-header>
    <div class="main-container">
      <div class="banner-container">
        <template v-if="!showSearch">
          <div class="search-container">
            <div class="order-no-container">
              <el-input
                v-model="orderNo"
                placeholder="请输入有效的顺丰集货单号"
                @keyup.native.enter="getResult(orderNo)"
              >
                <template>运单</template>
              </el-input>
              <!-- <div class="info warning" v-if="showError">
                                <i class="warning-flag"></i>您输入的订单号不存在，请检查或联系客服 95338！
                            </div> -->
            </div>
            <el-button type="primary" :loading="btnIsLoading" @click="getResult(orderNo)">查询</el-button>
          </div>
          <div class="add-btn-container">
            <el-button icon="el-icon-plus" type="text" @click="showSearchHandler">添加多个单号</el-button>
          </div>
        </template>
        <div v-if="showSearch" class="waybill-track">运单追踪</div>
      </div>
      <div class="result-content">
        <div v-if="showSearch" class="input-area">
          <div class="input-item">
            <span class="input-order">批 量</span>
            <el-input
              v-model="orderMore"
              placeholder="输入运单号查询，单次最多查20条，以逗号分隔"
              type="textarea"
              :rows="4"
            ></el-input>
          </div>

          <div class="search-btn-container">
            <el-button type="text" @click="hideSearchHandler">单一追踪号</el-button>
            <el-button class="search-btn" :loading="btnIsLoading" @click="batchSearch">查询</el-button>
          </div>
        </div>
        <div v-if="showSearch" class="block-divider"></div>
        <div v-if="isInit" class="init-content">
          <div class="qrcode-container">
            <img v-if="isPrd && !isDev" src="./images/appDownload-prd.png" width="125px" height="125px" alt="" />
            <img v-if="!isPrd && !isDev" src="./images/appDownload-sit.png" width="125px" height="125px" alt="" />
            <img v-if="isDev" src="./images/appDownload-sit.png" width="125px" height="125px" alt="" />
            <p class="qrcode-text">下载安装APP</p>
          </div>
          <div class="coop-partner">
            <!-- <p class="parner-text">合作伙伴</p>
            <div>
              <img src="./images/images/partner.png" alt="" />
            </div> -->
          </div>
        </div>
        <template v-if="result.orderList">
          <!-- <template v-if="true"> -->
          <div class="order-list-container">
            <div class="result-text">根据您的查询单号，找到多个结果</div>
            <div
              v-for="(item, index) in result.orderList"
              :key="index"
              class="order-item"
              @click="getResult(item.omsNo)"
            >
              <div v-if="item.deliveryNoSF && item.deliveryNoSF.length > 0" class="waybill-no">
                运单号{{ item.omsNo }} ({{ item.deliveryNoSF ? item.deliveryNoSF : '' }})
              </div>
              <div v-else class="waybill-no">运单号{{ item.omsNo }}</div>

              <div class="order-item-main">
                <div>
                  <i class="el-icon-circle-check-outline">
                    <svg
                      t="1685002567401"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="3486"
                      width="32"
                      height="32"
                    >
                      <path
                        d="M507.912176 10.219561C227.896208 10.219561 1.021956 237.093812 1.021956 517.10978s226.874251 506.89022 506.89022 506.89022 506.89022-226.874251 506.890219-506.89022S787.928144 10.219561 507.912176 10.219561z m0 955.528942c-247.824351 0-448.638723-200.814371-448.638723-448.638723s200.814371-448.638723 448.638723-448.638722S956.550898 269.796407 956.550898 517.10978 755.736527 965.748503 507.912176 965.748503z"
                        p-id="3487"
                      ></path>
                      <path
                        d="M824.207585 339.800399c0-15.840319-12.774451-28.61477-28.614771-28.61477-10.219561 0-18.906188 5.620758-24.015968 13.285429l-338.267465 338.267465-178.331337-178.331337c-11.241517-11.241517-29.125749-11.241517-40.367266 0s-11.241517 29.125749 0 40.367265l218.698603 218.698603 383.233533-383.233533-0.510978-0.510978c5.10978-5.10978 8.175649-12.263473 8.175649-19.928144z"
                        p-id="3488"
                      ></path>
                    </svg>
                  </i>
                  <span>{{ item.issuePartyCity }}</span>
                  <span>→</span>
                  <span>{{ item.receivePartyCity }}</span>
                </div>
                <div>
                  <span>{{ item.orderStatus }}</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div v-if="result.orderDetail" class="result-content">
        <template>
          <div class="total-info">
            <div class="go-back-container">
              <el-button v-if="orderList.length > 0" icon="el-icon-back" type="text" @click="goBack">
                返回列表
              </el-button>
            </div>
            <div class="order-no">
              <span
                v-if="orderDetail.ordInfo.deliveryNoSF && orderDetail.ordInfo.deliveryNoSF.length > 0"
                class="gray-text"
              >
                运单号({{ orderDetail.ordInfo.clientType }})：{{ orderDetail.ordInfo.omsNo }} ({{
                  orderDetail.ordInfo.deliveryNoSF ? orderDetail.ordInfo.deliveryNoSF : ''
                }})
              </span>

              <span v-else class="gray-text">
                运单号({{ orderDetail.ordInfo.clientType }})：{{ orderDetail.ordInfo.omsNo }}
              </span>
              <el-tooltip
                class="item"
                effect="dark"
                content="运输已用时间 = 当前时间 -【 寄件时间 或 计划发件时间 】"
                placement="top-start"
              >
                <span class="used-time">运输已用时间：{{ orderDetail.ordInfo.shipUsedTime }}小时</span>
              </el-tooltip>
            </div>
            <div class="status-container">
              <div class="status-icon"></div>
              <div class="status-text">
                <div class="big-font">{{ orderDetail.ordInfo.orderStatus }}</div>
                <!-- <div class="footer-text">
                  {{ orderDetail.ordInfo.currentCity }} | 当地时间 {{ orderDetail.ordInfo.currentTime }}
                </div> -->
              </div>
            </div>
            <div class="icon-divider"></div>
            <div class="from-to-info">
              <div class="left-container">
                <div class="from">从</div>
                <div class="city">{{ orderDetail.ordInfo.issuePartyCity }}</div>
                <div class="time">{{ orderDetail.ordInfo.actualPieceTime }}</div>
              </div>
              <div class="right-container">
                <div class="from">{{ orderDetail.ordInfo.deliveryDate ? '已送达至' : '送达至' }}</div>
                <div class="city">
                  <!-- 优先取子仓名称 没有子仓名称取城市名称 -->
                  {{ orderDetail.pdaList?.[0]?.subWarehouseName ?? orderDetail.ordInfo.receivePartyCity }}
                </div>
                <div class="time">
                  {{ orderDetail.ordInfo.deliveryDate || orderDetail.ordInfo.requestedDeliveryDte }}
                </div>
              </div>
            </div>
            <el-row class="product-info">
              <!-- <el-col v-if="orderDetail.ordInfo.podPicUrl" :span="6">
                <span
                  class="document-container"
                  @click="showImg(orderDetail.ordInfo.picturePrefix + orderDetail.ordInfo.podPicUrl)"
                >
                  <i class="el-icon-document"></i>
                  POD
                </span>
              </el-col> -->
            </el-row>
          </div>
          <div class="dash-divider"></div>
          <div class="horizontal-step">
            <!-- <div class="use-time">已用时间：{{orderDetail.ordInfo.orderUsedTime}}小时</div> -->
            <div class="step-container">
              <el-steps>
                <el-step
                  v-for="(item, index) in orderDetail.ordProcessList"
                  :key="index"
                  :class="{ active: item.procStatus, 'last-active': lastActiveIndex == index }"
                  :title="item.procName"
                >
                  <template slot="icon">
                    <img class="place-order" height="60px" width="60px" :src="item.procPic[item.procStatus]" />
                  </template>
                  <template slot="title">
                    <i>{{ item.procName }}</i>
                    <!-- <i v-for="(child, childIndex) in item.procPic" :key="childIndex" class="el-icon-picture"
                    @click="showImg(orderDetail.ordInfo.picturePrefix + child)"></i> -->
                  </template>
                  <template v-if="lastActiveIndex == index" slot="title">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="运输已用时间 = 当前节点时间 - 下单时间"
                      placement="top-start"
                    >
                      <div class="use-time">已用时间：{{ orderDetail.ordInfo.orderUsedTime }}小时</div>
                    </el-tooltip>
                  </template>
                </el-step>
              </el-steps>
            </div>
            <div class="hidden-detail">
              <el-button
                v-if="showRouteDetail"
                icon="el-icon-arrow-up"
                type="text"
                @click="showRouteDetail = !showRouteDetail"
              >
                隐藏详情
              </el-button>
              <el-button
                v-if="!showRouteDetail"
                icon="el-icon-arrow-down"
                type="text"
                @click="showRouteDetail = !showRouteDetail"
              >
                显示详情
              </el-button>
            </div>
          </div>
          <div v-show="showRouteDetail" class="dash-divider"></div>
          <div v-show="result.orderDetail && !orderDetail.ordRouteList && showRouteDetail" class="empty-content">
            <div class="img-container">
              <img src="./images/images/empty.png" alt="" />
              <p>暂无路由跟踪信息，请稍后重新查询！</p>
            </div>
          </div>
          <div v-show="showRouteDetail" class="router-info">
            <div class="router-list">
              <el-steps direction="vertical">
                <el-step v-for="(item, index) in orderDetail.ordRouteList" :key="index" :title="item.nodeName">
                  <!-- <template slot="title">
          
                  </template> -->
                  <!-- <template> -->
                  <template slot="icon">
                    <img
                      v-if="index == 0 && orderDetail.ordRouteList.length != 1"
                      class="place-order-left"
                      src="./images/images/endPlane.png"
                      alt=""
                    />
                    <img
                      v-if="index == orderDetail.ordRouteList.length - 1"
                      class="place-order-left"
                      src="./images/images/startPlane.png"
                      alt=""
                    />
                    <img
                      v-if="index != 0 && index != orderDetail.ordRouteList.length - 1"
                      src="./images/images/node.png"
                      class="place-order-left"
                      alt=""
                    />
                  </template>
                  <template slot="description">
                    <div v-for="(childItem, chdIndex) in item.nodeList" :key="chdIndex" class="description-item">
                      <span class="time">{{ chdIndex == 0 ? item.nodeTime : '' }}</span>
                      <span :class="{ 'except-type': childItem.nodeEvent, city: true }">
                        <!-- 配送中 已经签收 将城市名替换为子仓名称 -->
                        {{
                          ['06', '07'].includes(childItem.nodeCode)
                            ? orderDetail.pdaList?.[0]?.subWarehouseName || childItem.nodeCity || childItem.nodeEvent
                            : childItem.nodeCity || childItem.nodeEvent
                        }}
                      </span>
                      <span class="except-content">{{ childItem.nodeDesc }}</span>
                    </div>
                  </template>
                  <!-- </template> -->
                  <!-- <div>{{ item.nodeName }}</div>
                    <div v-for="(childItem, chdIndex) in item.nodeList" :key="chdIndex" class="description-item">
                      <span class="time">{{ chdIndex == 0 ? item.nodeTime : '' }}</span>
                      <span :class="{ 'except-type': childItem.nodeEvent, city: true }">
                        {{ childItem.nodeCity || childItem.nodeEvent }}
                      </span>
                      <span class="except-content">{{ childItem.nodeDesc }}</span>
                    </div> -->
                </el-step>
              </el-steps>
            </div>
          </div>
          <!-- 列表 -->
          <div v-show="showRouteDetail" class="dash-divider"></div>
          <div class="horizontal-step">
            <div class="hidden-detail">
              <el-button
                v-if="showListDetail"
                icon="el-icon-arrow-up"
                type="text"
                @click="showListDetail = !showListDetail"
              >
                隐藏子单列表
              </el-button>
              <el-button
                v-if="!showListDetail"
                icon="el-icon-arrow-down"
                type="text"
                @click="showListDetail = !showListDetail"
              >
                显示子单列表
              </el-button>
            </div>
          </div>
          <div v-show="result.orderDetail && !orderDetail.pdaList && showListDetail" class="empty-content">
            <div class="img-container">
              <img src="./images/images/empty.png" alt="" />
              <p>暂无数据</p>
            </div>
          </div>
          <div v-show="showListDetail && orderDetail.pdaList" class="list-info">
            <el-table :data="pdaListToShow" style="width: 100%" height="250">
              <el-table-column fixed prop="productNo" label="单号"></el-table-column>
              <el-table-column fixed prop="operatorTime" label="扫描时间"></el-table-column>
              <el-table-column fixed prop="subWarehouseName" label="子仓名称"></el-table-column>
            </el-table>
            <el-pagination
              :current-page.sync="pagination.current"
              :page-size.sync="pagination.pageSize"
              :page-sizes="pagination.pageSizeOptions"
              :total="pagination.total"
              :layout="pagination.layout"
              @size-change="pagination.handleSizeChange"
            ></el-pagination>
          </div>
          <div></div>
        </template>
      </div>
      <el-dialog title="预览" class="img-dialog" :visible.sync="showPreview" width="800px">
        <img :src="previewSrc" alt="" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Row, Col, Button, Select, Option, Input, Steps, Step, Message, Tooltip, Table, Pagination } from 'element-ui'
  import cHeader from './chead/header.vue'
  import { getOrderDetailAndList, getValidToken } from './api/orderSearch/api'
  // import common from '@/util/common'

  import './fonts/iconfont.css'
  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Steps)
  Vue.use(Step)
  Vue.use(Tooltip)
  Vue.use(Table)
  Vue.use(Pagination)
  Vue.prototype.$message = Message
  // Vue.prototype.$alert = MessageBox.alert;
  // Vue.prototype.$confirm = MessageBox.confirm;
  export default {
    name: 'OrderSearch',
    components: {
      cHeader,
    },
    data() {
      return {
        orderList: [], // 订单列表
        orderNo: '', // 单号
        orderNoList: ['', '', '', ''], // 订单号列表
        orderMore: '', // 订单号列表
        orderMoreList: ['', '', '', ''], // 订单号列表
        result: {},
        btnIsLoading: false, // 按钮显示加载中，默认为false
        showRouteDetail: true, // 显示路由详情
        showListDetail: true, // 显示列表详情
        showSearch: false, // 显示五个查询框
        showDetail: false, // 详情是否显示
        isInit: true, // 初始化
        showPreview: false, // 显示图片预览弹框
        previewSrc: '', // 预览图片路径
        orderDetail: {
          ordInfo: {
            omsNo: '',
            shipUsedTime: '',
            orderStatus: '',
            currentCity: '',
            currentTime: '',
            issuePartyCity: '',
            receivePartyCity: '',
            actualPieceTime: '',
            deliveryDate: '',
            requestedDeliveryDte: '',
            orderUsedTime: '',
            productName: '',
            orderQty: '',
            orderWt: '',
            podPicUrl: '',
            deliveryNoSF: '',
          },
          ordProcessList: [],
          ordRouteList: [],
          omsNoAndDeliveryNoSF: '', //需要处理后在显示详情
        },
        // 新结构 old
        order: {},
        // 新增的分页配置数据
        pagination: {
          total: 0,
          current: 1, // 当前页数
          pageSize: 10, // 每页条数
          pageSizeOptions: ['10', '20', '50', '100'],
          layout: 'total, prev, pager, next, sizes',
          handleSizeChange: () => {
            this.current = 1
          },
        },
        validToken: '',
        captcha: '',
        isPrd: location.href.indexOf('sit') == -1,
        isDev: process.env.NODE_ENV === 'development',
      }
    },
    computed: {
      lastActiveIndex() {
        let result = 0
        this.orderDetail.ordProcessList.forEach((item, index) => {
          if (item.procStatus == 1) {
            result = index
          }
        })
        return result
      },
      // 分页数据
      pdaListToShow() {
        const startIndex = (this.pagination.current - 1) * this.pagination.pageSize
        const endIndex = this.pagination.current * this.pagination.pageSize
        return (
          (this.orderDetail.pdaList &&
            this.orderDetail.pdaList.filter((data, index) => index >= startIndex && index < endIndex)) ||
          []
        )
      },
    },
    created() {
      let orderNo = sessionStorage.getItem('orderNo')
      if (orderNo) {
        this.orderNo = orderNo
        sessionStorage.removeItem('orderNo')
        // this.searchOrder();
      }
      // eslint-disable-next-line no-undef
      if (initGeetest4) {
        // eslint-disable-next-line no-undef
        initGeetest4(
          {
            captchaId: 'd3808acf3487a31e3666aa586935dc3d',
            product: 'bind',
          },
          captcha => {
            this.captcha = captcha
          }
        )
      }
    },
    methods: {
      async getResult(orderNo) {
        if (!this.validToken) {
          await this.getToken()
          if (!this.validToken) {
            return
          }
        }
        if (orderNo.length == 0) {
          return this.$message.warning('请输入运单号')
        }
        //判断是否数组
        let pam = []
        if (Array.isArray(orderNo)) {
          pam = orderNo
        } else {
          pam.push(orderNo)
        }

        console.log(pam)
        // 获取查询结果
        this.btnIsLoading = true
        getOrderDetailAndList({ omsNos: pam, token: this.validToken })
          .then(async res => {
            this.btnIsLoading = false
            var that = this
            if (res.status == 200 && res.data.status == '9') {
              await this.getToken()
              this.getResult(orderNo)
              return
            }
            if (res.status == 200 && res.data.status != '1') {
              const { Msg } = res.data
              // return this.$message.warning(res.detail)
              return this.$message.warning(Msg)
            }
            const { data } = res.data

            // console.log(data, '==res.data')
            this.isInit = false

            // this.result = data
            // console.log(data, 'resultdata')

            if (res.data) {
              try {
                this.result = JSON.parse(that.decryption(data))
              } catch (error) {
                this.result = that.decryption(data)
              }
            }
            //this.result = res.data
            // console.log(this.result, 'result2')
            // console.log(JSON.stringify(this.result), 'result2')
            if (this.result.order) {
              this.JSONOrderWithOrdInfo(this.result)
            } else if (this.result.orderList) {
              this.orderList = this.result.route || []
            }
            // 单个查询
            if (this.result.orderDetail) {
              this.orderDetail = this.result.orderDetail || {}
              console.log(JSON.stringify(this.orderDetail), ' this.orderDetail-1')
              let ordProcessList = this.orderDetail.ordProcessList
              console.log(JSON.stringify(ordProcessList), 'ordProcessList')

              //  this.orderDetail.ordInfo.omsNo = orderNo // 运单号由前端带给

              ordProcessList.forEach(item => {
                this.$set(item, 'procPic', [])
                if (item.procType == 1 && item.procCode == '08') {
                  item.procPic = [
                    require(`./images/images/${item.procCode}_bill_un.png`),
                    require(`./images/images/${item.procCode}_bill.png`),
                  ]
                } else {
                  item.procPic = [
                    require(`./images/images/${item.procCode}_un.png`),
                    require(`./images/images/${item.procCode}.png`),
                  ]
                }
              })

              this.orderDetail.ordProcessList = ordProcessList // 添加图片
              // this.orderDetail.ordRouteList = this.result.orderDetail.ordRouteList // 添加图片

              // console.log(this.orderDetail.ordProcessList, 'ordProcessList3')
              // console.log(this.orderDetail.ordRouteList, 'ordProcessList4')

              this.showDetail = true
            } else if (this.result.orderList) {
              this.orderList = this.result.orderList || []
            }
            // 重置分页配置数据
            this.pagination.current = 1
            this.pagination.total = (this.orderDetail.pdaList && this.orderDetail.pdaList.length) || 0
          })
          .catch(() => {
            this.btnIsLoading = false
          })
      },
      JSONOrderWithOrdInfo(orderJson) {
        this.order = orderJson.order
        //var routeData= orderJson.route
        // 先按照 barScanTm 时间升序排序
        const sortedRoute = orderJson.route.sort((a, b) => a.opCode - b.opCode)
        console.log(sortedRoute)
        this.orderDetail.ordInfo = {
          omsNo: this.orderNo,
          actualPieceTime: this.order.actualPieceTime,
          currentCity: this.order.currentCity,
          currentTime: this.order.deliveryDate,
          issuePartyCity: this.order.issuePartyCity,
          productName: this.order.productName,
          deliveryDate: this.order.deliveryDate,
          receivePartyCity: this.order.receivePartyCity,
          orderReceivedDte: this.order.orderReceivedDte,
          orderQty: this.order.orderQty,
          orderWt: this.order.orderWt,
          orderStatus: sortedRoute[sortedRoute.length - 1].opName,
          deliveryNoSf: this.order.deliveryNoSf,
        }
        //  const opName = this.result.data.route[this.result.data.route.length - 1].opName;
        //  const opName = this.result.data.route[this.result.data.route.length - 1].opName;
        console.log(JSON.stringify(this.orderDetail))
      },
      batchSearch() {
        // 批量查询订单
        if (this.orderMore.length == 0) {
          return this.$message.warning('请输入运单号')
        }
        console.log(this.orderMore, 'orderMoreList')
        let orderNoArray = this.orderMore.split(',') // 将字符串以逗号分隔为数组
        console.log(orderNoArray.length, 'orderMoreList')
        if (orderNoArray.length > 20) {
          return this.$message.warning('输入运单号查询，单次最多查20条')
        }
        // for (let i in orderNoArray) {
        //   if (!!orderNoArray[i] && orderNoArray[i].split(',').length > 20) {
        //     return this.$message.warning('每个输入框最多只能输入20个单号')
        //   }
        // }
        //let orderNoArrayWithoutLargeNumber = orderNoArray.filter(item => item <= 20) // 删除大于20的元素
        let orderNoSet = new Set(orderNoArray) // 使用Set进行去重
        let orderNoArrayWithoutDuplicate = Array.from(orderNoSet) // 将Set转换为数组
        console.log(orderNoArrayWithoutDuplicate, 'orderNoArrayWithoutDuplicate') // 输出 [ '1', '2', '3', '4', '5' ]
        //let orderNo = orderNoArrayWithoutDuplicate.join(',')
        this.getResult(orderNoArrayWithoutDuplicate)
      },
      async getToken() {
        try {
          const captchaResult = await this.getCaptcha()
          const data = await getValidToken(captchaResult)
          if (data.status == 200 && data.data.status != 1) {
            this.$message.error(data.data.Msg || '服务端错误')
          }
          this.validToken = data?.data?.data?.token
        } catch (e) {
          this.$message.error(e.message || '服务端错误')
        }
      },

      getCaptcha() {
        return new Promise(resolve => {
          try {
            const that = this
            this.captcha.showCaptcha()
            this.captcha.onSuccess(() => {
              const result = that.captcha.getValidate()
              resolve(result)
            })
          } catch (err) {
            this.$alert('滑块验证码加载失败，请检查网络后再试！', '提示', {
              confirmButtonText: '确定',
            })
          }
        })
      },
      testNo() {
        // 校验单号
        if (!(/^[0-9]{12}$|^SF[0-9]{13}$/.test(this.orderNo) || /^[0-9]{11}$/.test(this.orderNo))) {
          // 十二位数字或者SF开头的15位字符串，或者11位主单号
          // this.showError = true; // 不通过校验，显示通用错误信息
          return false
        } else {
          return true
        }
      },
      showSearchHandler() {
        // 显示批量查询
        this.showSearch = true
        this.orderNo = ''
        //
        this.orderNoList = []
        this.orderMore = ''
      },
      hideSearchHandler() {
        // 隐藏批量查询
        this.showSearch = false
        this.orderNoList = []
        this.orderMore = ''
        this.orderNo = ''
      },
      showImg(url) {
        // 显示预览图片
        this.previewSrc = url
        this.showPreview = true
      },
      goBack() {
        // 返回列表
        this.result = {
          orderList: this.orderList,
          orderDetail: null,
        }
      },
    },
  }
</script>

<style lang="scss">
  .index-wrapper {
    .main-container {
      position: relative;

      .img-dialog {
        img {
          width: 100%;
        }
      }

      .banner-container {
        background: #343753;
        background-size: cover;
        padding: 30px 0 5px;

        .waybill-track {
          width: 878px;
          margin: 0 auto;
          color: #fff;
          font-size: 18px;
          font-weight: bold;
          padding-bottom: 10px;
        }

        .add-btn-container {
          width: 878px;
          margin: 0 auto;

          .el-button--text.el-button {
            i {
              color: #fff;
            }

            span {
              color: #fff;
            }
          }
        }

        .search-container {
          display: flex;
          width: 878px;
          margin: 0 auto;

          .el-input-group__prepend {
            width: 142px;
            text-align: center;
            color: #333;
            background: #fff;
            font-weight: bold;
            font-size: 18px;
            border: 1px solid #fff;
            border-right: 1px solid #ddd;
          }

          .order-no-container {
            flex: 1;
            display: relative;

            .el-input {
              width: 100%;

              .el-input__inner {
                height: 60px;
                border-radius: 0 !important;
                border: 0;
                font-size: 18px;
              }
            }
          }

          .el-button {
            width: 142px;
            height: 60px;
            font-size: 20px;
            font-weight: bold;
            background: #cccccc;
            border: 0;
            color: #333;

            &.hover {
              opacity: 0.5;
            }
          }
        }
      }

      .result-content {
        background: #fff;
        width: 1200px;
        margin: 0 auto 0 auto;
        box-shadow: #999;

        .input-area {
          width: 878px;
          margin: 0 auto;
          padding-top: 50px;

          .input-item {
            border: 1px solid #efeff7;
            border-left: 2px solid #313152;
            margin-bottom: 20px;
            background: #fff;
            padding: 10px 50px 10px 0;
            display: flex;

            .input-order {
              padding: 0 10px 0 20px;
              border-right: 1px solid #313152;
              font-weight: bold;
              line-height: 40px;
            }

            .el-input {
              flex: 1;

              input {
                border: 0;
                font-size: 18px;
              }
            }
          }

          .search-btn-container {
            display: flex;
            padding-bottom: 30px;
            justify-content: space-between;

            .el-button {
              &.search-btn {
                background: #313131;
                width: 100px;
              }

              &.el-button--text {
                span {
                  color: #9c9c9c;
                  font-weight: bold;
                }
              }
            }
          }
        }
        .search-btn {
          color: #fff;
        }
        .block-divider {
          border: 1px dashed #cecece;
        }

        .order-list-container {
          width: 878px;
          margin: 0 auto 20px;
          padding-top: 20px;

          .result-text {
            font-size: 18px;
            color: #636363;
            background: #efefef;
            padding: 30px 10px;
          }

          .order-item {
            padding: 5px 10px 30px;
            border: 1px solid transparent;
            border-bottom: 1px solid #cecece;
            cursor: pointer;

            &:hover {
              border: 1px solid #313131;
            }

            .waybill-no {
              margin: 5px 0 10px;
            }

            .order-item-main {
              display: flex;
              justify-content: space-between;
              font-size: 18px;

              .el-icon-circle-check-outline {
                font-size: 35px;
                align-self: center;
                position: relative;
                top: 6px;
                margin-right: 5px;
              }
            }
          }
        }

        // border: 1px solid #ddd;
        .init-content {
          .qrcode-container {
            padding-top: 110px;
            text-align: center;
            border-bottom: 1px dashed #ddd;

            p.qrcode-text {
              text-align: center;
              margin-top: 23px;
              padding-bottom: 95px;
              font-size: 16px;
            }
          }

          .coop-partner {
            text-align: center;
            padding-bottom: 55px;

            .parner-text {
              line-height: 100px;
              font-size: 18px;
              font-weight: bold;
            }

            img {
              width: 900px;
            }
          }
        }

        .empty-content {
          padding: 141px 0 175px 0;

          .img-container {
            text-align: center;

            img {
              margin-bottom: 30px;
            }

            p {
              font-size: 18px;
              color: #999;
            }
          }
        }

        .el-step__description.is-wait {
          color: #333;
        }

        .total-info {
          width: 878px;
          margin: 0 auto;

          .go-back-container {
            .el-button {
              i,
              span {
                color: #999;
              }

              &:hover {
                color: #333;
              }
            }

            padding-top: 10px;
          }

          .order-no {
            padding: 10px 0;

            .gray-text {
              color: #9c9c9c;
              margin-right: 10px;
            }

            .used-time {
              font-weight: bold;
            }
          }

          .status-container {
            display: flex;

            .status-icon {
              width: 80px;
              height: 58px;
              background: url('./images/images/signed.png') no-repeat;
              margin-right: 10px;
            }

            .status-text {
              .big-font {
                font-size: 33px;
                color: #42c69c;
                font-weight: bold;
              }

              .footer-text {
                color: #6b636b;
                margin-top: 5px;
              }
            }
          }

          .icon-divider {
            height: 10px;
            background: url('./images/images/signProcessBar.png') no-repeat;
            background-size: contain;
            margin: 12px 0;
          }

          .from-to-info {
            display: flex;
            justify-content: space-between;

            .left-container {
              text-align: left;

              .from {
                color: #b5adb5;
              }

              .city {
                font-size: 18px;
                margin: 5px 0;
              }
            }

            .right-container {
              text-align: right;

              .from {
                color: #b5adb5;
              }

              .city {
                font-size: 18px;
                margin: 5px 0;
              }
            }
          }

          .product-info {
            margin: 10px 0;

            .document-container {
              cursor: pointer;
            }
          }
        }

        .dash-divider {
          border: 1px dashed #ddd;
          margin: 20px 0;
        }

        .horizontal-step {
          width: 878px;
          margin: 0 auto;

          .use-time {
            text-align: left;
            position: relative;
            top: -145px;
            left: -30px;
          }

          .step-container {
            margin-top: 65px;
            margin-left: 10px;

            .el-step {
              .el-step__main {
                .el-step__title {
                  color: #b7b7b7;
                  margin-left: -10px;

                  .el-icon-picture {
                    cursor: pointer;
                  }
                }
              }

              &.active {
                .el-step__main {
                  .el-step__title {
                    color: #333;
                  }
                }

                .el-step__head {
                  .el-step__line {
                    background: #333;
                  }
                }

                &.last-active {
                  .el-step__head {
                    .el-step__line {
                      height: 0;
                      border: 1px dashed #333;
                      background: #fff;
                    }
                  }
                }
              }

              &:last-of-type {
                .el-step__title {
                  font-weight: bold;
                }
              }
            }
          }

          .hidden-detail {
            .el-button {
              i,
              span {
                color: #999;
              }
            }

            margin-top: 10px;
          }
        }

        .router-info {
          width: 878px;
          margin: 0 auto;
          padding: 20px 0;

          .router-list {
            margin-left: 120px;

            .el-steps {
              .el-step {
                .el-step__head {
                  .el-step__icon {
                    border: 0;
                  }

                  .el-step__line {
                    background: #eee;
                  }
                }

                &:first-of-type {
                  .el-step__head {
                    .el-step__line {
                      background: #000;
                    }
                  }

                  .el-step__description {
                    .description-item {
                      font-weight: bold;
                    }
                  }
                }

                &:last-of-type {
                  .el-step__main {
                    .el-step__description {
                      border: 0;
                    }
                  }
                }

                .el-step__main {
                  .el-step__title {
                    position: absolute;
                    left: -200px;
                    color: #666;
                    width: 180px;
                    text-align: right;
                    font-weight: bold;
                  }

                  .el-step__description {
                    padding: 15px 0;
                    font-size: 14px;
                    border-bottom: 1px dashed #ddd;
                    margin-left: 40px;
                    position: relative;
                    top: -10px;

                    .description-item {
                      line-height: 25px;
                      display: flex;

                      .time {
                        display: inline-block;
                        width: 170px;
                        flex-shrink: 0;
                      }

                      .city {
                        margin-right: 15px;
                        flex-shrink: 0;
                      }

                      .except-type {
                        color: #ffa500;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .list-info {
          width: 878px;
          margin: 0 auto;
          padding: 20px 0;

          .el-table th {
            color: #333;
          }

          .el-pagination .el-pager {
            color: #333;
            .number.active {
              color: #42c69c;
            }
          }
        }
      }
    }

    // .fixed{
    //     position: fixed;
    //     bottom: 0;
    // }
  }
</style>
